import { supabase } from './supabase.js';
import { toCamel } from './case.js';

/**
 * Subscribe to changes on a table.
 *
 * @param {string} table - Table name (e.g., 'tasks')
 * @param {function} onChange - Called with { event, row } where event is INSERT/UPDATE/DELETE
 * @param {object} filter - Optional filter, e.g., { column: 'pair_id', value: 'abc' }
 * @returns {function} - Unsubscribe function
 */
export function subscribeToTable(table, onChange, filter = null) {
  let channel = supabase.channel(`changes-${table}-${Date.now()}`);

  const config = {
    event: '*',
    schema: 'public',
    table,
  };
  if (filter) {
    config.filter = `${filter.column}=eq.${filter.value}`;
  }

  channel = channel.on('postgres_changes', config, (payload) => {
    onChange({
      event: payload.eventType, // INSERT, UPDATE, DELETE
      row: toCamel(payload.new || payload.old),
      old: toCamel(payload.old),
    });
  });

  channel.subscribe();

  return () => {
    supabase.removeChannel(channel);
  };
}

/**
 * Subscribe to all task changes for current user's pair.
 * Returns unsubscribe function.
 */
export function subscribeToTasks(onChange) {
  // We let RLS do the filtering — we just listen to all task changes
  // and only the ones we have permission to see will arrive.
  return subscribeToTable('tasks', onChange);
}

/**
 * Subscribe to shopping list changes for current user's pair.
 */
export function subscribeToShopping(onChange) {
  return subscribeToTable('shopping_items', onChange);
}

/**
 * Subscribe to notifications for current user.
 */
export function subscribeToNotifications(userId, onChange) {
  return subscribeToTable('notifications', onChange, {
    column: 'recipient_id',
    value: userId,
  });
}
